<template>
  <div class="informative-view-page">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <app-page-header title="Notícia"></app-page-header>

    <div class="informative-container" v-if="!isLoading">
      <h1>{{ informative.title }}</h1>
      <h2>{{ informative.headline }}</h2>
      <span>{{ informative.datetime | date }}</span>
      <p v-html="informative.text"></p>
      <img :src="informative.image" alt="Imagem do Informativo" />
    </div>

    <div class="other-informatives">
      <informatives></informatives>
    </div>
  </div>
</template>

<script>
import InformativeService from '@/services/informative.service';
import Informatives from '@/components/LandingPage/Informatives.vue';

export default {
  name: 'informative-view-page',
  components: {
    Informatives,
  },
  data: () => {
    return {
      isLoading: true,
      informative: {},
    };
  },
  methods: {
    loadInformative(id) {
      this.isLoading = true;

      InformativeService.getId(id)
        .then(({ data }) => {
          this.informative = data;
        })
        .finally(() => (this.isLoading = false));
    },
  },
  watch: {
    $route({ params }) {
      this.loadInformative(params.id);
    },
  },
  beforeMount() {
    const id = this.$route.params.id;
    id && this.loadInformative(id);
  },
};
</script>

<style lang="scss" scoped>
.informative-container {
  margin: 0 15vw;

  h1 {
    font-weight: bold;
    font-size: 2em;
    color: var(--color-primary);
  }

  h2 {
    font-weight: normal;
    font-size: 1.2em;
    color: var(--text-color-light);
  }

  span {
    color: var(--text-color-light);
  }

  p {
    font-size: 1.1em;
    line-height: 1.5em;
    margin-top: 2em;
  }

  img {
    margin-top: 2em;
    max-width: 720px;
    width: 100%;
  }
}
.other-informatives {
  margin-top: 4em;
}
</style>
